import React from 'react'
import { connect } from 'react-redux';
import { PatientHomeAdmissionHeader, PatientHomeAdmissionBody, PatientHomeAdmissionStartEvalOptions, PatientHomeAdmissionStartEvalOptionsPeds } from 'PatientCareCenter/Home/Admissions'
import styles from './Admission.module.css'
import { PatientHomeAdmissionSpecialProgRequest } from './SpecialProgRequest';
import { PatientHomeAdmissionStartNoteWarnings } from './StartNoteWarning';
import { PatientHomeAdmissionNoteWarnings } from './NoteWarnings';
import { PatientHomeAdmissionStartNoteScribe } from './StartNoteScribe';

class PatientHomeAdmission extends React.Component {

    render() {
        return (
            <div key={this.props.id} className={styles.admission}>
                <PatientHomeAdmissionHeader id={this.props.id} />
                {this.props.specialProgReqVisible &&
                    <PatientHomeAdmissionSpecialProgRequest id={this.props.id} />
                }
                {this.props.scribeVisible &&
                    <PatientHomeAdmissionStartNoteScribe id={this.props.id} />
                }
                {this.props.message !== undefined && this.props.message !== "" &&
                    <PatientHomeAdmissionNoteWarnings id={this.props.id}></PatientHomeAdmissionNoteWarnings>
                }
                {this.props.startEvalOptionsVisible &&
                    <PatientHomeAdmissionStartEvalOptions id={this.props.id} status={this.props.startEvalOptionsStatus} thurno={this.props.thurno} />
                }
                {this.props.showWarning &&
                    <PatientHomeAdmissionStartNoteWarnings id={this.props.id} />
                }
                <PatientHomeAdmissionBody id={this.props.id} />
            </div>
        )
    }
}

function mapStateToProps(state, ownprops) {
    let scribeVisible = state.ui.admissions[ownprops.id].newScribeVisible ? true : false;
    let message = undefined;
    if (state.ui.admissions[ownprops.id].startNoteDisplayWarnings !== undefined) {
        if (state.ui.admissions[ownprops.id].startNoteDisplayWarnings !== "") {
            message = state.ui.admissions[ownprops.id].startNoteDisplayWarnings;
        }
    }

    return {
        specialProgReqVisible: state.ui.admissions[ownprops.id].specialProgReqVisible,
        startEvalOptionsVisible: state.ui.admissions[ownprops.id].startEvalOptionsVisible,
        startEvalPedsOptionsVisible: state.ui.admissions[ownprops.id].startEvalPedsOptionsVisible,
        startEvalOptionsStatus: state.ui.admissions[ownprops.id].startEvalOptionsStatus,
        admission: state.entities.admissions[ownprops.id],
        thurno: state.ui.admissions[ownprops.id].thurno,
        showWarning: state.ui.admissions[ownprops.id].startNoteWarning ? true : false,
        scribeVisible,

        message
    };
}

const connectedPatientHomeAdmission = connect(mapStateToProps)(PatientHomeAdmission);
export { connectedPatientHomeAdmission as PatientHomeAdmission };